// extracted by mini-css-extract-plugin
module.exports = {"priceInputContainer":"sLQUz","priceInput":"_2rWTc","priceTitle":"_11_eR","bg":"_1QF10","open":"zJ1B5","saveBtn":"_3PQF0"};